var opened = 0;
var start = $('#arriveInput').attr('value');
var end = $('#departureInput').attr('value');


// Func = limiting Scope for this file
(function(){

	function resizeWindow(){

	}

	const bookingHolder = document.querySelector('.booking-holder');
	const bookingNav = {
		bookingOpen: document.querySelector('.booking-trig-js'),
		bookingClose: document.querySelector('.close-booking-js')
	};

	if(bookingHolder) {
		bookingNav.bookingOpen.addEventListener('click', function () {
			bookingHolder.classList.add('open');
		});
		bookingNav.bookingClose.addEventListener('click', function () {
			bookingHolder.classList.remove('open');
		});
	}
	if(document.getElementsByClassName('js-cta-widget').length > 0){
		document.getElementsByClassName('js-cta-widget')[0].addEventListener('click', function(){
			
			document.getElementById('bookingVacation').classList.add('open')
		})
		document.getElementsByClassName('js-booking-close')[0].addEventListener('click', function(){
			document.getElementById('bookingVacation').classList.remove('open')
		})
	}

	//animations below
	const animateHTML = function () {
		let elems,
			windowHeight;
		let init = function () {
			elems = document.getElementsByClassName('hide-object');
			windowHeight = window.innerHeight;
			addEventHandlers();
		};
		let addEventHandlers = function () {
			window.addEventListener('scroll', checkPosition);
			window.addEventListener('resize', init);
		};
		let checkPosition = function () {
			for (let i = 0; i < elems.length; i++) {
				let posFromTop = elems[i].getBoundingClientRect().top;
				if (posFromTop - windowHeight <= 0) {
					elems[i].className = elems[i].className.replace('hide-object', 'show-object')
				}
			}
		};
		return {
			init: init
		}
	};
	animateHTML().init();
	//end animations

	$(document).ready(function () {

		//Call function with browser is resized.
		$(window).resize(function (event) {
			resizeWindow();
		});
		resizeWindow();

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		// primary nav
		$('#burgerMenu').click(function(){
			if(!$(this).hasClass('active')){
				$(this).addClass('active')
				var windowH = $(window).height() - 100;
				$('#primary-nav').addClass('active')
				if(document.getElementById('header').classList.contains('home')){
					document.getElementById('header').classList.remove('home');
				}
				if(!$('#primary-nav').hasClass('tablet')){
					$('#primary-nav').addClass('tablet')
					$('#primary-nav').wrapInner('<div class="tablet-block"></div>')
				}

				$('#primary-nav').animate({height:windowH + 'px'}, 500);
			} else {
				$(this).removeClass('active')
				$('#primary-nav').removeClass('active')
				if(document.getElementById('home') && window.pageYOffset < 50 ){
					document.getElementById('header').classList.add('home');
				}
			}
		});

		////Nav Scroll to section
		//$('a[href*="#list-3col-5283"]').click(function(){
		//	$([document.documentElement, document.body]).animate({
		//		scrollTop: $("#list-3col-5283").offset().top - 90
		//	}, 1500);
		//});

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";		
        $( "#CheckIn" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
            dateFormat: DATE_FORMAT,
            changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			}
		});



		//To create after event 
		$.datepicker._updateDatepicker_original = $.datepicker._updateDatepicker;
		$.datepicker._updateDatepicker = function (inst) {
			$.datepicker._updateDatepicker_original(inst);
			var afterShow = this._get(inst, 'afterShow');
			if (afterShow)
				afterShow.apply((inst.input ? inst.input[0] : null));  // trigger custom callback
		}
		//alert($('#arriveInput').val());

		$('#bookingCalendar').datepicker({
			changeMonth: false,
			dateFormat: 'mm/dd/yy',
			numberOfMonths: 2,
			minDate:0,
			beforeShowDay: function (date) {

				setTimeout(function() {
					document.querySelectorAll('.ui-datepicker-calendar td a').forEach(e => {
						e.setAttribute('tabindex', '-1');
					})
				}, 1000);

				$.datepicker._defaults.dateFormat = "mm/dd/yy";
				var startDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
				var endDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
				if (date.getTime() == startDate.getTime()) {
					return [true, "startday"];
				} else {
					if (date.getTime() == endDate.getTime()) {
						return [true, "endday"];
					} else {
						if (date.getTime() > startDate.getTime() && date.getTime() < endDate.getTime()) {
							return [true, "days"];
						} else {
							return [true, ""];
						}
					}
				}
			},
			onSelect: function (date) {
				var arrive = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
				var selectedDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, date);

				if (opened == 0) {
					opened = 1;
					start = date;
					end = date;
				} else {
					opened = 0;
					if (selectedDate <= arrive) {
						
						if(datediff(arrive,selectedDate) < 7){
							
							let newEnd = $('#bookingCalendar').datepicker('getDate');
            				newEnd.setDate(newEnd.getDate()+7);
							Date.prototype.mmddyyyy = function() {
								let mm = this.getMonth() + 1; // getMonth() is zero-based
								let dd = this.getDate();
								
								return [(mm>9 ? '' : '0') + mm +'/',
										(dd>9 ? '' : '0') + dd +'/',
										this.getFullYear()
										].join('');
							};
						
							end = newEnd.mmddyyyy();
							
						} else {
							end = start;
						}
						start = date;

					} else {
					
						if(datediff(arrive,selectedDate) < 7){
							let daysDifference = 7 - (datediff(arrive,selectedDate));
							let newEnd = $('#bookingCalendar').datepicker('getDate');
            				newEnd.setDate(newEnd.getDate()+daysDifference);
							Date.prototype.mmddyyyy = function() {
								let mm = this.getMonth() + 1; // getMonth() is zero-based
								let dd = this.getDate();
								
								return [(mm>9 ? '' : '0') + mm +'/',
										(dd>9 ? '' : '0') + dd +'/',
										this.getFullYear()
										].join('');
							};
							
							end = newEnd.mmddyyyy();
						} else {
							end = date;
						}
					}
					
					
				}

				$('#arriveInput').attr('value', start);
				$('#departureInput').attr('value', end);
				$('#fullDates').attr('value', start +' - ' + end);
			
			},
			onChangeMonthYear: function () {
			
			}
		});




		// Map: Return to previous page button. Change body id to match map template's name.
		$('body#map-category #content').prepend('<a class="btn btn__map btn__map--previous" href="javascript:history.back()">« Back to previous page</a>');
		$('body#map-category #content').prepend('<a class="btn btn__map btn__map--ada" href="/marathon/ada-map">View ADA Map</a>');

		//HP compass effect on scroll down arrow
		var compass_img = $('.arrow-home__compass--arrow');
		if (compass_img.length > 0) {
			var offset = compass_img.offset();

			function mouse(evt) {
				var center_x = (offset.left) + (compass_img.width() / 2);
				var center_y = (offset.top) + (compass_img.height() / 2);
				var mouse_x = evt.pageX;
				var mouse_y = evt.pageY;
				var radians = Math.atan2(mouse_x - center_x, mouse_y - center_y);
				var degree = (radians * (180 / Math.PI) * -1) + 90;
				compass_img.css('-moz-transform', 'rotate(' + degree + 'deg)');
				compass_img.css('-webkit-transform', 'rotate(' + degree + 'deg)');
				compass_img.css('-o-transform', 'rotate(' + degree + 'deg)');
				compass_img.css('-ms-transform', 'rotate(' + degree + 'deg)');
			}
			$(document).mousemove(mouse);
		}

		function startSlider(){
			$('.sym-slides-local').slick(
				{"arrows": false, "dots": true, "autoplay": false, "autoplaySpeed": 5000, "speed": 500, "fade": true, "accessibility": false, "pauseOnHover":false, "pauseOnHover":false}
			);
		};

		startSlider();

		$('#default .title--uvp, #default-alt .title--uvp, .title--megatitle, .each-item__flavor-text li').each(function(){
			$(this).addClass('uvp-transition');
			$(this).html($(this).text().replace(/([^a-z0-9``~!@#$%^&*°()\-_=+\[\]{}\\|;:'"<>,./?\s\r\n]|\w)/g, "<span class='letter'>$&</span>"));
		});
		$('#home .title--uvp span').each(function(){
			$(this).addClass('uvp-transition');
			$(this).html($(this).text().replace(/([^\x00-\xFF]|\w)/g, "<span class='letter-home'>$&</span>"));
		});
		$('.title--megatitle, .each-item__flavor-text li').each(function(){
			$(this).addClass('hide-object');
		});
		$('#home .title--uvp div').each(function(){
			$(this).addClass('uvp-fade');
		});


		setTimeout(function(){
			$('#home .title--uvp span, #home .title--uvp div, #default .title--uvp.uvp-transition, #default-alt .title--uvp.uvp-transition').addClass('initiate');
		}, 800);
		
		$(".specials-filter #window-view").on("change", function (e) {
			e.preventDefault();
			var filterArea = $(this).closest(".filter").attr("data-filter-section");
			var filterby = $(this).val();
			if (filterby == "see-all") {
				$(".filter-block").show();
				$(".filter-block .animate-fade").addClass("fade-in visible");
			} else {
				var selectedBlocks = $("#" + filterArea).children(
				".filter-block[data-filter*='" + filterby + "']"
				);
				$("#" + filterArea)
				.children(".filter-block[data-filter*='" + filterby + "']")
				.remove();
				$(".filter-block").hide();
				$(selectedBlocks).prependTo("#" + filterArea);
				$("#" + filterArea)
				.children(".filter-block[data-filter*='" + filterby + "']")
				.show();
				$("#" + filterArea)
				.children(".filter-block[data-filter*='" + filterby + "']")
				.find(".animate-fade")
				.addClass("fade-in visible");
			}
			$(".filter-block .sym-slides").slick("unslick");
			$(".filter-block .sym-slides").slick({
				accessibility: false,
			});
		});

		$('.slip-rental-container #boat_info_yes').change(function(){
			$('.slip-rental-container .slip-rental-additional-info').show();
		});

		$('.slip-rental-container #boat_info_no').change(function(){
			$('.slip-rental-container .slip-rental-additional-info').hide();
		});
	});

	$(window).on('load', function(){
		$('.arrow-home').addClass('initiate');
	});
	// remove attribute for ADA
	$('#third-nav').removeAttr('aria-label');
}());

function parseDate(str) {
    var mdy = str.split('/');
    return new Date(mdy[2], mdy[0]-1, mdy[1]);
}
function datediff(first, second) {
    return Math.round((second-first)/(1000*60*60*24));
} 